module.exports = __webpack_public_path__ + "static/media/b4.343ad6bd.PNG";